import { supabase } from './supabase';
import type { RestorationWorkRow } from './restorationDatabase.types';

export function restorationWorkOutstanding(row: RestorationWorkRow): boolean {
  const nextAttempt = Date.parse(row.next_attempt_at);
  const created = Date.parse(row.created_at);
  return !Number.isFinite(nextAttempt) || !Number.isFinite(created)
    || Boolean(row.lease_until || row.last_error) || nextAttempt <= created;
}

export type RestorationWorkStatus = Record<string, boolean | undefined>;

/** Owner RLS applies. Missing rows/errors remain retryable, never imply completion. */
export async function hasOutstandingRestorationWork(itemIds: string[], onStatus?: (status: RestorationWorkStatus) => void): Promise<boolean> {
  const { data, error } = await supabase.from('restoration_item_valuations')
    .select('item_id,created_at,next_attempt_at,lease_until,last_error').in('item_id', itemIds);
  if (error) throw error;
  const status: RestorationWorkStatus = {};
  for (const id of itemIds) {
    const row = data?.find(candidate => candidate.item_id === id);
    status[id] = row ? restorationWorkOutstanding(row) : undefined;
  }
  onStatus?.(status);
  return itemIds.some(id => status[id] !== false);
}
